var map = {
	"./audio-icon@2x.png": "6c48",
	"./doc-icon@2x.png": "aa6b",
	"./excel-icon@2x.png": "fba8",
	"./file-icon@2x.png": "5c51",
	"./image-icon@2x.png": "96fa",
	"./mp3-icon@2x.png": "c117",
	"./mp4-icon@2x.png": "edca",
	"./open-icon@2x.png": "1573",
	"./pdf-icon@2x.png": "a61a",
	"./ppt-icon@2x.png": "a07c",
	"./service-icon@2x.png": "eb68",
	"./txt-icon@2x.png": "9b9b",
	"./unknow-icon@2x.png": "bafc",
	"./video-icon@2x.png": "dc2e",
	"./word-icon@2x.png": "ba5b",
	"./xlsx-icon@2x.png": "80b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3817";